import { render, staticRenderFns } from "./wxTest.vue?vue&type=template&id=484b916a"
import script from "./wxTest.vue?vue&type=script&lang=js"
export * from "./wxTest.vue?vue&type=script&lang=js"
import style0 from "./wxTest.vue?vue&type=style&index=0&id=484b916a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports